<div class="row">
  <div *ngIf="labelName" class="col-md-4 col-12">
    <label class="control-label" for="{{ labelName ? labelName : 'efan' }}">
      <span [ngClass]="required ? 'required' : ''">*</span>
      {{ labelName }}
    </label>
  </div>
  <div [ngClass]="{ 'col-md-8 col-12': labelName, 'col-12': !labelName }">
    <input
      (blur)="emitBlur()"
      (ngModelChange)="changeModel($event)"
      [ngClass]="{
        requiredField: !isValid && !submitted,
        errorRequiredField: !isValid && submitted,
      }"
      [ngModel]="inputModel"
      class="form-control"
      id="{{ labelName ? labelName : 'efan' }}"
      name="efan"
      placeholder=""
      type="text"
    />
  </div>
  <pre *ngIf="environment.useDebugMode">
inputModel: {{ inputModel }}
    isValid {{ isValid }}</pre
  >
  <div
    *ngIf="submitted && !isValid"
    class="col-12 errorText"
    id="validationError"
  >
    <i class="fa fa-circle-o fa-lg circle-position"></i>
    <i class="fa fa-exclamation exclamation-position"></i>
    <p class="col ps-2 ms-4 input-validation-text">
      Enter a valid efan of length 10.
    </p>
  </div>
  <div *ngIf="!submitted || isValid" class="col-12">
    <p></p>
  </div>
</div>
